import styled from "styled-components";
import params from "../../global/params.json";

const containerParams = params.container;

export const Container = styled.div`
  padding: 90px 0px 0px 0px;
  width: 100%;
  margin: 0 auto;
  .background-trading {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    z-index: -1;
  }
  /* .trading-row {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    gap: 10px;
    margin-bottom: 100px;
  }
  
  .trading-card {
    background-color: var(--background);
    padding: 20px;
    /* border-radius: 20px;
    height: unset;
  }
  @media screen and (max-width: 950px) {
    .trading-row {
      grid-template-columns: 1fr;
    }
    .extra-button {
      display: none;
    }
  } */

  .MuiGrid-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-bottom: 90px;
  }
  .MuiGrid-spacing-xs-2 {
    width: calc(100% + 16px) !important;
    margin: -8px;
  }
  .MuiGrid-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
  }
  .MuiGrid-item {
    padding: 8px;
  }
  .MuiGrid-item {
    margin: 0;
    box-sizing: border-box;
  }
  .MuiGrid-grid-xs-12 {
    flex-grow: 0;
    max-width: 100%;
    flex-basis: 100%;
  }
  @media (min-width: 1280px) {
    .MuiGrid-grid-lg-3 {
      flex-grow: 0 !important;
      max-width: 25% !important;
      flex-basis: 25% !important;
    }
  }
  .bg-palette {
    background-color: #1b1e29;
  }
  .jss542 {
    color: rgb(105, 108, 128);
    padding: 8px;
    font-size: 0.875rem;
    /* font-family: Inter, sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .text-uppercase {
    text-transform: uppercase;
  }
  .text-secondary {
    color: #696c80;
  }
  .searchInputWrapper {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin: 12px 0;
    font-size: 16px;
    border-radius: 12px;
    outline: none;
    border: 2px solid rgba(105, 108, 128, 0.12);
    background-color: #12131a;
  }
  .jss542 {
    color: rgb(105, 108, 128);
    padding: 8px;
    font-size: 0.875rem;
    /* font-family: Inter, sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .searchInputWrapper svg {
    margin-right: 12px;
  }
  .searchInputWrapper input {
    background: 0 0;
    flex: 1 1;
    box-shadow: none;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 500;
    color: #696c80;
  }
  .MuiTableContainer-root {
    width: 100%;
    overflow-x: auto;
  }
  .MuiTable-root {
    width: 100%;
    display: table;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .datatableWrapper .table {
    width: 100%;
  }
  .tableContainer thead {
    height: 53px;
  }
  .MuiTableHead-root {
    display: table-header-group;
  }
  .MuiTableRow-root {
    color: inherit;
    display: table-row;
    outline: 0;
    vertical-align: middle;
  }
  .tableContainer thead tr th:first-child {
    padding: 7px 0 7px 23px;
  }
  .tableContainer thead tr th {
    padding: 7px 6px;
    cursor: pointer;
  }
  tbody {
    max-height: 100vh !important;
  }
  .tableContainer tbody tr td,
  .tableContainer thead tr th {
    font-size: 14px;
    border-bottom: 1px solid rgba(130, 177, 255, 0.08);
  }
  .MuiTableCell-head {
    color: #c7cad9;
    font-weight: 500;
    line-height: 1.5rem;
  }
  .MuiTableCell-root {
    display: table-cell;
    padding: 16px;
    font-size: 0.875rem;
    text-align: left;
    /* font-family: "Inter", sans-serif; */
    font-weight: 500;
    line-height: 1.43;
    border-bottom: 1px solid rgba(240, 245, 255, 1);
    vertical-align: inherit;
  }
  .datatableWrapper .headCellLabel {
    color: #696c80;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .sortRequestedHeadLabel {
    color: #448aff;
  }
  .jss931 {
    width: 28px;
    height: 28px;
    border-radius: 28px;
  }
  .currencyLogo {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .bg-white {
    background-color: #fff;
  }
  .ml-1 {
    margin-left: 1rem;
  }
  .jss933 {
    width: 100%;
  }
  .text-success {
    color: #0fc679;
  }
  .text-error {
    color: #ff5252;
  }
  .small,
  small {
    font-size: 14px;
    line-height: 1.57;
  }
  th,
  td {
    background: transparent;
  }
  td {
    color: var(--primaryColor);
    padding: 6px !important;
    height: 57px;
  }
  .MuiGrid-spacing-xs-2 > .MuiGrid-item {
    padding: 8px;
  }
  .MuiGrid-grid-xs-12 {
    flex-grow: 0;
    max-width: 100%;
    flex-basis: 100%;
  }
  .swapProWrapper {
    flex: 1 1;
    max-height: 100vh;
    min-height: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .jss563 {
    color: rgb(105, 108, 128);
    padding: 8px;
    font-size: 0.875rem;
    /* font-family: Inter, sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .bg-palette {
    background-color: #1b1e29;
  }
  .jss565 {
    color: rgb(105, 108, 128);
    padding: 8px;
    font-size: 0.875rem;
    /* font-family: Inter, sans-serif; */
    font-weight: 500;
    line-height: 1.43;
    .coin-swap {
      padding: 8px;
    }
    .coin-input {
      background-color: #2c3242;
    }
  }
  .mt-1 {
    margin-top: 1rem;
  }

  .jss623 {
    color: rgb(105, 108, 128);
    padding: 8px;
    font-size: 0.875rem;
    /* font-family: Inter, sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .MuiTable-root {
    width: 100%;
    display: table;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .tableContainer thead {
    height: 53px;
  }
  .tableContainer thead tr th:first-child {
    padding: 7px 0 7px 23px;
  }
  div.buy {
    color: #0fc679;
  }
  div.sell {
    color: #ff5252;
  }
  .MuiTablePagination-root {
    color: #c7cad9;
    overflow: auto;
    font-size: 0.875rem;
  }
  .MuiTablePagination-root:last-child {
    padding: 0;
  }
  .MuiTablePagination-toolbar {
    min-height: 52px;
    padding-right: 2px;
  }
  .MuiToolbar-regular {
    min-height: 56px;
  }
  .MuiToolbar-gutters {
    padding-left: 16px;
    padding-right: 16px;
  }
  .MuiToolbar-root {
    display: flex;
    position: relative;
    align-items: center;
  }
  .MuiTablePagination-spacer {
    flex: 1 1 100%;
  }
  .MuiTablePagination-caption {
    flex-shrink: 0;
  }
  .MuiTypography-body2 {
    font-size: 0.875rem;
    /* font-family: "Inter", sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .h6,
  .p,
  h6,
  p {
    line-height: 1.5;
  }
  .MuiTablePagination-input {
    color: inherit;
    font-size: inherit;
    flex-shrink: 0;
  }
  .MuiTablePagination-selectRoot {
    margin-left: 8px;
    margin-right: 32px;
  }
  .MuiInputBase-root {
    color: #c7cad9;
    cursor: text;
    display: inline-flex;
    position: relative;
    font-size: 1rem;
    box-sizing: border-box;
    align-items: center;
    /* font-family: "Inter", sans-serif; */
    font-weight: 500;
    line-height: 1.1876em;
  }
  .MuiTablePagination-select {
    text-align: right;
    padding-left: 8px;
    padding-right: 24px;
    text-align-last: right;
  }
  .MuiSelect-selectMenu {
    height: auto;
    overflow: hidden;
    min-height: 1.1876em;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .MuiSelect-select {
    cursor: pointer;
    min-width: 16px;
    user-select: none;
    border-radius: 0;
    /* -moz-appearance: none;
    -webkit-appearance: none; */
  }
  .MuiInputBase-input {
    font: inherit;
    color: currentColor;
    width: 100%;
    border: 0;
    height: 1.1876em;
    margin: 0;
    display: block;
    min-width: 0;
    background: none;
    box-sizing: content-box;
    animation-name: mui-auto-fill-cancel;
    letter-spacing: inherit;
    animation-duration: 10ms;
    -webkit-tap-highlight-color: transparent;
  }
  .MuiSelect-nativeInput {
    left: 0;
    width: 100%;
    bottom: 0;
    opacity: 0;
    position: absolute;
    pointer-events: none;
  }
  .MuiSelect-icon {
    top: calc(50% - 12px);
    color: rgba(0, 0, 0, 0.54);
    right: 0;
    position: absolute;
    pointer-events: none;
  }
  .MuiSvgIcon-root {
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    user-select: none;
  }
  .MuiTablePagination-caption {
    flex-shrink: 0;
  }
  .MuiTypography-colorInherit {
    color: inherit;
  }
  .MuiTypography-body2 {
    font-size: 0.875rem;
    /* font-family: "Inter", sans-serif; */
    font-weight: 500;
    line-height: 1.43;
  }
  .MuiTablePagination-actions {
    flex-shrink: 0;
    margin-left: 20px;
  }
  .MuiIconButton-root.Mui-disabled {
    color: set color of text here;
    background-color: transparent;
  }
  .MuiIconButton-root.Mui-disabled {
    color: set color of text here;
    background-color: transparent;
  }
  .MuiIconButton-root {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.54);
    padding: 12px;
    overflow: visible;
    font-size: 1.5rem;
    text-align: center;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border-radius: 50%;
  }
  .MuiIconButton-label {
    width: 100%;
    display: flex;
    align-items: inherit;
    justify-content: inherit;
  }
  .span,
  span {
    font-size: 12px;
    line-height: 1.33;
  }
  .MuiIconButton-root {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.54);
    padding: 12px;
    overflow: visible;
    font-size: 1.5rem;
    text-align: center;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border-radius: 50%;
  }
  .MuiIconButton-colorInherit {
    color: inherit;
  }
  .MuiButtonBase-root {
    color: inherit;
    border: 0;
    cursor: pointer;
    margin: 0;
    display: inline-flex;
    outline: 0;
    padding: 0;
    position: relative;
    align-items: center;
    user-select: none;
    border-radius: 0;
    vertical-align: middle;
    /* -moz-appearance: none; */
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    /* -webkit-appearance: none; */
    -webkit-tap-highlight-color: transparent;
  }
  @media (min-width: 0px) and (orientation: landscape) {
    .MuiToolbar-regular {
      min-height: 48px;
    }
  }
  @media (min-width: 700px) {
    .MuiToolbar-gutters {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
  @media (min-width: 700px) {
    .MuiToolbar-regular {
      min-height: 64px;
    }
  }
  @media (min-width: 1280px) {
    .MuiGrid-grid-lg-6 {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
    }
  }

  .weight-600 {
    font-weight: 600;
  }
  .items-center {
    align-items: center;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex {
    display: flex;
  }
  .weight-600 {
    font-weight: 600;
  }
  .p,
  p {
    font-size: 16px;
  }
  .h6,
  .p,
  h6,
  p {
    line-height: 1.5;
  }
`;
